import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=6309a9db&scoped=true"
import script from "./SalesHistory.vue?vue&type=script&lang=js"
export * from "./SalesHistory.vue?vue&type=script&lang=js"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=6309a9db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309a9db",
  null
  
)

export default component.exports